import React from "react";
import { Link } from "react-router-dom";
import LeftSideBar from "./LeftSideBar";

const SideBar = () => {
  return <LeftSideBar />;
};

export default SideBar;
